import React from 'react';
import style from './onsite.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function OnsiteLanding(props) {

  //Set the window size state to maintain media queries
  const [gridSize, setGridSize] = useState(0)
  
  useEffect (() => {
		const handleGridResize = () => {
      let limit = 0
			if (props.windowSize === "Web") {
        //set column limit
        limit = 4
      } else if (props.windowSize === "Tablet") {
          //set column limit
          limit = 2
      } else {
        //set column limit
        limit = 4
      }

			if (limit !== gridSize) {
				setGridSize(limit)
			}
		}
		
		window.addEventListener('resize', handleGridResize)

		handleGridResize()

		return () => {
			window.removeEventListener('resize', handleGridResize)
		}
  }) 

  let mainPath = '/e2-engineering-services/onsite-services/'
  let linkArr = [
    'Troubleshooting and Support',
    'System Maintenance and Testing',
    'NERC Compliance Testing',
    'Technical Training'
  ]

  //Handles css grid layout for IE
  let linkElements = []
  let colCount = 1
  let rowCount = 1
  let linkCount = 0

  for (let i = 0; i < linkArr.length; i++) {
    if (props.windowSize !== "Mobile") {
      let classStr = ``

      //Add a right border to every cell that is not the last column in a row
      if (((linkCount + 1) % gridSize) !== 0) {
        classStr += ` ${style.borderRight}`
      }

      //Add a bottom border to every cell that is not in the last row
      if (rowCount < ((Math.floor(linkArr.length / gridSize) + 1) - 1)) {
        classStr += ` ${style.borderBottom}`
      } 

      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a className={classStr} style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    } else {
      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    }

    //Check if column gridSize has been reached
    if (colCount === gridSize) {
      colCount = 1
      rowCount++
    } else {
      colCount++
    }

    linkCount++
  }

  //Handles style grid by creating the circle elements and changing the columns/rows accordingly (Tablet and Web only)
  let circles = null
  let styleBox1 = null
  let styleBox2 = null
  let styleBox3 = null
  let styleGrid = null
  let limit = 0

  if (props.windowSize !== "Mobile") {
    limit = 9
    colCount = 1
    rowCount = 1
    circles = []

    for (let x = 0; x < (7 * 9); x++) {

      //Creating accent circle
      circles[x] = <span key={"span" + x} style={{msGridRow: rowCount, msGridColumn: colCount}}></span>

      if (colCount === limit) {
        colCount = 1
        rowCount++
      } else {
        colCount++
      }
    }

    styleBox1 = <div className={style.styleBoxOne}></div>
    styleBox2 = <div className={style.styleBoxTwo}></div>
    styleBox3 = <div className={style.styleBoxThree}></div>
    styleGrid = <div className={style.styleGrid}>{circles}</div>
  }

  return (
    <div className={style.OnsiteLanding}>
      <Head>
        <title>Onsite Services | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> E&#178; Engineering Services</a></Link></li>
        <span>/</span>
      </div>
      <h3>Onsite Services</h3>
      <div className={style.quickLinkContainer}>
        {styleBox1}
        {styleBox2}
        {styleBox3}
        {styleGrid}
        <div className={style.quickLinks}>
          {linkElements}
        </div>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[0]}</h4>
        <p>When your unit is down, you need help. Our qualified, knowledgeable engineers have the necessary field experience to understand your issues and answer your questions.  Basler Services&#39; engineers provide emergency troubleshooting services over the phone, free of charge. If your needs are more complex, we will dispatch one of our field engineers to your site based on time and materials required.</p>
        <Link href={mainPath + linkArr[0].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[1]}</h4>
        <p>A quality, periodic system maintenance program by experts from Basler Services will provide you the information and tools to achieve greater reliability of your generating system. Regular maintenance will enhance unit performance, improve in-house system troubleshooting ability and help reduce your overall system operation and maintenance costs.</p>
        <Link href={mainPath + linkArr[1].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[2]}</h4>
        <p>Standards are either currently in place or are being developed by regional councils, requiring baseline and periodic (every 5 years) testing and verification of power plant models for units greater than 10MVA. This requires that the generator, excitation system, turbine governor, over excitation limiter and power system stabilizer parameters be verified through comparison of simulated dynamic responses to field test measurements.</p>
        <Link href={mainPath + linkArr[2].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[3]}</h4>
        <p>Our objective is to support operating plants in their goal to achieve the highest effectiveness from their own technical staff and equipment. Each training program is developed to meet the specific needs of our clients. We will structure the course content to provide the background information as well as the path forward for your system.</p>
        <Link href={mainPath + linkArr[3].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      {/* <div className={style.quickInfoSection}>
        <h4>{linkArr[4]}</h4>
        <p>Basler Services, LLC can provide service agreements for any of the services you need.</p>
        <Link href={mainPath + linkArr[4].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div> */}
    </div>
  );
}

export default OnsiteLanding;